import { render, staticRenderFns } from "./template-upload.vue?vue&type=template&id=42ca6a97&scoped=true&"
import script from "./template-upload.vue?vue&type=script&lang=js&"
export * from "./template-upload.vue?vue&type=script&lang=js&"
import style0 from "./template-upload.vue?vue&type=style&index=0&lang=less&"
import style1 from "./template-upload.vue?vue&type=style&index=1&id=42ca6a97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca6a97",
  null
  
)

export default component.exports